module.exports = {
  "defaultLanguage": "en-US",
  "languages": [
    {
      "code": "en-US",
      "name": "English",
      "icon": null
    },
    {
      "code": "es-MX",
      "name": "Mexican",
      "icon": null
    }
  ]
}